import { render, staticRenderFns } from "./IncludedVideos.vue?vue&type=template&id=215df601"
import script from "./IncludedVideos.vue?vue&type=script&lang=js"
export * from "./IncludedVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loadmore: require('/home/forge/meidenvanholland.nl/components/loadmore.vue').default})
